import React, { useState } from 'react';
import useGetSettingsForPlan from '../../sales/hooks/useGetPlanSettings';
import { useFetchUrlClustersQuery } from '../urlClusters/service';
import { useFetchServiceableUrlsCountQuery } from './service';
import { Button, Modal } from 'antd';
import AddServiceableUrlsWizard from './wizard/AddServiceableUrlsWizard';
import { skipToken } from '@reduxjs/toolkit/query';


type Props = {
    websiteGuid: string | undefined;
};


export default function AddServiceableUrlsButton({ websiteGuid }: Props) {
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

    const { data: urlClusters } = useFetchUrlClustersQuery(websiteGuid ? { w_guid: websiteGuid } : skipToken);
    const { data: serviceableUrlsCountData } = useFetchServiceableUrlsCountQuery(websiteGuid ? { w_guid: websiteGuid } : skipToken);
    const { dpMaxServiceableUrls: maximumServiceableUrls } = useGetSettingsForPlan();

    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
    };

    const hasData = !!websiteGuid && !!urlClusters && !!maximumServiceableUrls && !!serviceableUrlsCountData;
    const showButton = hasData && serviceableUrlsCountData.count < maximumServiceableUrls;

    return (
        <>
            {showButton && (
                <>
                    <Button
                        className="deep-analysis-small-button"
                        type="primary"
                        size="small"
                        onClick={toggleModal}
                    >
                        Add new URLs
                    </Button>
                    <Modal
                        visible={isModalVisible}
                        title="Add new URLs"
                        footer={null}
                        onCancel={toggleModal}
                        destroyOnClose={true}
                    >
                        <AddServiceableUrlsWizard
                            websiteGuid={websiteGuid}
                            clusters={urlClusters}
                            maximumAllowedUrls={maximumServiceableUrls - serviceableUrlsCountData.count}
                            onFinish={toggleModal}
                        />
                    </Modal>
                </>
            )}
        </>
    );
}
